import ListaPreciosService from "@/services/catalogos/ListaPreciosService";

const fetch = (context, params) => {
  return ListaPreciosService.fetch(params)
    .then(res => {
      context.commit('LISTA_PRECIOS', res.data);
    });
};

const set = (context, params) => {
  console.log(params);
  context.commit('LISTA_PRECIO_SELECCIONADA', params);
}

export default {
  fetch,
  set,
};
